/* import __COLOCATED_TEMPLATE__ from './alert.hbs'; */
import { bool } from '@ember/object/computed';
import Component from '@ember/component';
import { task } from 'ember-concurrency';
import { closeModal } from 'sh-www/utils/modal-controls';

export default Component.extend({
  tagName: '',

  hasTitleImage: bool('model.titleImage.image'),
  hasTitleImageDefault: bool('model.titleImage.default'),
  hasTitleText: bool('model.titleText'),
  hasBodyText: bool('model.bodyText'),
  hasActionButtonText: bool('model.actionButtonText'),
  confirmTask:  task(function *() {
    if(typeof this.get('model.confirmAction') === 'function') {
      // model.confirmAction should return a promise of some kind so that it can run
      // before the modal closes.
      yield this.get('model.confirmAction').bind(this)();
      closeModal(this);
    } else {
      closeModal(this);
    }
  }),
  actions: {
    confirmAction() {
      this.get('confirmTask').perform();
    },
  }
});
